import React from "react";
import { useMediaQuery } from "react-responsive";
import FoloWarning from "../images/FoloWarning.png";
import Updatepng from "../images/Updatepng.png";
import { Box } from "../styles/Box";
import { Button } from "../styles/Button";
import { Container } from "../styles/Container";
import { Heading } from "../styles/Heading";
import { Paragraph } from "../styles/Paragraph";
import { primaryColorScales } from "../theme/styles";

type Props = {
  showTryAgain?: boolean;
  onTryAgain?: () => void;
};

const ErrorPage = (props: Props) => {
  const { showTryAgain, onTryAgain } = props;

  const isMobile = useMediaQuery({
    query: "(min-width: 320px) and (max-width: 599px)",
  });

  return (
    <Container
      sx={{
        minHeight: "340px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 20px 0 20px",
        backgroundColor: primaryColorScales.greyScale[1],
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          flexDirection: "column",
          gap: "20px",
          width: isMobile ? "88%" : "344px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            style={{ width: "80px", height: "80px" }}
            src={FoloWarning}
            alt="Warning triangle"
          />
        </Box>
        <Heading as="h2" variant="h2">
          Pensionsräknaren gick inte att visa.
        </Heading>
        <Paragraph>
          Försök ladda om sidan eller ring kundservice på 0771-950 950 om du
          behöver hjälp.
        </Paragraph>
        {showTryAgain && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Button
              onClick={onTryAgain}
              sx={{
                backgroundColor: "#dc142c",
                minWidth: isMobile ? "100%" : "12rem",
              }}
            >
              Försök igen
              <img src={Updatepng} alt="Update icon" />
            </Button>
          </Box>
        )}
      </Box>
    </Container>
  );
};
export default ErrorPage;
